import { APP_SETTING_ROUTES } from 'shared/consts/routes/app-settings';
import { MenuAddButton } from 'shared/ui/section-menu';

export function AddButton() {
  return (
    <MenuAddButton
      path={APP_SETTING_ROUTES.ADD_APP_SETTING}
      requiredRights={[
        {
          controller: 'Settings',
          right: 'Write',
        },
      ]}
    />
  );
}
